import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  Switch,
} from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import { Show } from '@ui/components/Show';
import { useFormContext, useWatch } from 'react-hook-form';

export function ImportFilesConfiguration() {
  const form = useFormContext<SnapSiteConfigEditFormDataUnvalidated>();
  const sendImportFilesToVisual = useWatch({
    control: form.control,
    name: 'sendImportFilesToVisual',
  });

  return (
    <Flex direction="column" gap={4} w="full">
      <Show when={sendImportFilesToVisual}>
        <FormControl
          isInvalid={!!form.formState.errors.importFileSizeLimitBytes}
          isDisabled={!form.watch('useImportLineItems')}
        >
          <FormLabel htmlFor="import_file_size_limit_input">
            Import File Size Limit (MB):
          </FormLabel>

          <Input
            id="import_file_size_limit_input"
            type="number"
            inputMode="numeric"
            {...form.register('importFileSizeLimitBytes')}
            min={1}
          />

          <ErrorMessage
            name="importFileSizeLimitBytes"
            render={({ message }) => (
              <FormErrorMessage>{message}</FormErrorMessage>
            )}
          />

          <FormHelperText>
            Maximum file size for import files sent to Visual. Default is 10MB.
          </FormHelperText>
        </FormControl>
      </Show>

      <FormControl isInvalid={!!form.formState.errors.sendImportFilesToVisual}>
        <Flex direction="row" align="center" gap={2}>
          <Switch
            id="send_import_files_to_visual_input"
            {...form.register('sendImportFilesToVisual')}
            isDisabled={!form.watch('useImportLineItems')}
          />
          <FormLabel htmlFor="send_import_files_to_visual_input" mb={0}>
            Send Import files to Visual
          </FormLabel>
        </Flex>

        <ErrorMessage
          name="sendImportFilesToVisual"
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>
    </Flex>
  );
}
